import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class NamirialpayService {

  constructor(private http: HttpClient) {}

  GetCashFlowDetailToNamirialPay(fk_document: number,fk_dueInvoice: number=0): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/NamirialPay/GetCashFlowDetailToNamirialPay/" + fk_document + "/" + fk_dueInvoice).toPromise();
  }
  NamirialPayOnlineWS(fk_dueinvoice: number, servicepay: number): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + "/NamirialPay/NamirialPayOnlineWS/" + fk_dueinvoice + "/" + servicepay , null).toPromise();        
  }

  NamirialPayOnlineByIdOperazione(fk_dueinvoice: number, servicepay: number): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + "/NamirialPay/NamirialPayOnlineByIdOperazione/" + fk_dueinvoice + "/" + servicepay, null).toPromise();        
  }

  NamirialPaySendEmail(fk_dueinvoice: number, servicepay: number): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + "/NamirialPay/NamirialPaySendEmail/" + fk_dueinvoice + "/" + servicepay, null).toPromise();        
  }

  NamirialPayRemoveRequest(fk_dueInvoice: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/NamirialPay/NamirialPayRemoveRequest/' + fk_dueInvoice).toPromise();
  }

  NamirialPayLinkGetInfo(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/NamirialPay/NamirialPayLinkGetInfo/" + fk_company).toPromise();
  }

  NamirialPayUpdateInvoicesStatus(fk_company: number, selectedDueInvoicesID: Array<number>): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + "/NamirialPay/NamirialPayUpdateInvoicesStatus/" + fk_company , selectedDueInvoicesID).toPromise();        
  }
}
